import { useLocation, useNavigate } from 'react-router-dom'

import {
  type GeneralParticipationTab,
  GeneralParticipationTabs,
} from './../types/general-participation'

const useGeneralParticipationTab = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const pathToTabMap: { [key: string]: GeneralParticipationTab } = {
    '/general-participation/info': GeneralParticipationTabs.INFO,
    '/general-participation/cosplayer': GeneralParticipationTabs.COSPLAYER,
    '/general-participation/ticket': GeneralParticipationTabs.TICKET,
  }

  const getTabFromPathname = (pathname: string): GeneralParticipationTab => {
    return pathToTabMap[pathname] || GeneralParticipationTabs.INFO
  }

  const getPathFromTab = (tab: GeneralParticipationTab): string => {
    const entry = Object.entries(pathToTabMap).find(
      ([_, value]) => value === tab,
    )

    return entry ? entry[0] : '/general-participation/info'
  }

  const generalParticipationTab = getTabFromPathname(location.pathname)

  const setGeneralParticipationTab = (tab: GeneralParticipationTab) => {
    const path = getPathFromTab(tab)
    navigate(path)
  }

  return {
    generalParticipationTab,
    setGeneralParticipationTab,
  }
}

export default useGeneralParticipationTab
